import { useAppInsightsContext, useTrackEvent } from '@microsoft/applicationinsights-react-js';
import { useState } from 'react';

import { Assets, Button } from '@foradevelopment/fora-ui';
import { ReportingReceiptViewModel } from '@fora-monorepo/employer-my-pages-common/types';

import { ReportModal } from '../../components/Report/ReportModal';
import { useTypedTranslation } from '../../i18n/i18n';

export const ReportModalAndButton = ({
  reportIndex,
  getReportSummaryModalData,
}: {
  reportIndex: number;
  getReportSummaryModalData: (index: number) => Promise<ReportingReceiptViewModel>;
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTypedTranslation();
  const appInsights = useAppInsightsContext();
  const name = t('common.reportModalContentLabel');
  const trackOpenModal = useTrackEvent(appInsights, 'Report history - opened modal', { name }, true);

  return (
    <>
      <Button
        styleAs="link"
        onClick={() => {
          setModalOpen(true);
          trackOpenModal({ name });
        }}
      >
        <Assets.FileIcon width={10} marginRight={5} containerSize={12} />
        {name}
      </Button>
      <ReportModal
        isOpen={modalOpen}
        closeModal={() => setModalOpen(false)}
        getReportData={() => getReportSummaryModalData(reportIndex)}
      />
    </>
  );
};
